import { render } from "./Curtain.vue?vue&type=template&id=7a4113dc"
import script from "./Curtain.vue?vue&type=script&lang=js"
export * from "./Curtain.vue?vue&type=script&lang=js"

import "./Curtain.vue?vue&type=style&index=0&id=7a4113dc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__